import { defineMessages } from 'react-intl-next';

export default defineMessages({
	noDateSet: {
		id: 'date-range-picker.date-range.no-date-set',
		defaultMessage: 'No date set',
		description: 'Message to show when no date is set',
	},
	fiscalYearPrefix: {
		id: 'date-range-picker.date-range.fiscal-year-prefix',
		defaultMessage: 'FY',
		description: 'Fiscal year prefix used in interval labels (e.g. "Q1 FY26")',
	},
});
